import { requestJson } from "./http/httpClient";
import { readLiteral, readObject } from "./http/jsonDecoding";

/** `GET /health/ready` answered 200: the server and its database are reachable. */
export interface ReadinessReport {
  readonly status: "ready";
}

/**
 * Ask the server whether it can serve requests now (`server/src/dmw/api/health.py`).
 * A server that is up but cannot reach MongoDB rejects with the problem code
 * `dependency_unavailable`.
 */
export function readServerReadiness(signal?: AbortSignal): Promise<ReadinessReport> {
  return requestJson({
    method: "GET",
    path: "/health/ready",
    signal,
    decodeResponse: (body) => ({
      status: readLiteral(readObject(body, "readiness report"), "status", "ready"),
    }),
  });
}
